/* =========================================================
   CART / CHECKOUT PAGE — cart-page.js
   The section markup (sections/main-cart.liquid) server-renders a
   real <form action="/cart" method="post"> with native quantity
   inputs and a checkout submit button, so the page fully works with
   no JS at all. On load, if JS is available, we swap that in for an
   AJAX-driven version with +/- steppers, matching the rest of the
   site's interaction pattern (same as the cart drawer in global.js).
   ========================================================= */

function cartPageLineHTML(item, index) {
  return `
    <div class="cart-line-lg" data-line="${index + 1}">
      <img src="${item.image}" alt="${item.title}">
      <div class="cart-line-lg__info">
        <div class="cart-line-lg__title">${item.product_title}</div>
        <div class="cart-line-lg__meta">${item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : ""}</div>
        <div class="qty-stepper">
          <button class="qty-btn" type="button" data-qty-minus data-line="${index + 1}" aria-label="Decrease quantity">&minus;</button>
          <span class="qty-value">${item.quantity}</span>
          <button class="qty-btn" type="button" data-qty-plus data-line="${index + 1}" aria-label="Increase quantity">+</button>
        </div>
        <button class="chest-line__remove" type="button" data-remove data-line="${index + 1}">Release</button>
      </div>
      <div class="appraisal-price">${formatMoney(item.final_line_price)}</div>
    </div>
  `;
}

function renderCartPage(cart) {
  const container = document.getElementById("cart-page");
  if (!container) return;

  if (cart.item_count === 0) {
    container.innerHTML = `
      <div style="text-align:center; padding:60px 20px; max-width:var(--maxw); margin:0 auto;">
        <h1 style="font-size:28px; margin-bottom:12px;">Your chest is empty.</h1>
        <p style="margin-bottom:22px; color:var(--ink); font-weight:500;">Claim a lot from the catalogue to begin your voyage.</p>
        <a href="/collections/all" class="btn btn--seal">Browse the Catalogue</a>
      </div>
    `;
    return;
  }

  container.innerHTML = `
    <div class="cart-page-grid">
      <div class="cart-list">
        <h1 style="margin-bottom:18px;">Your Chest</h1>
        ${cart.items.map(cartPageLineHTML).join("")}
      </div>
      <div class="order-summary">
        <h3>Order Summary</h3>
        <div class="order-summary__row"><span>Subtotal</span><span>${formatMoney(cart.total_price)}</span></div>
        <div class="order-summary__row"><span>Shipping</span><span>Calculated at checkout</span></div>
        <div class="order-summary__total"><span>Total</span><span>${formatMoney(cart.total_price)}</span></div>
        <button class="btn btn--seal" id="place-order" type="button" style="width:100%; justify-content:center;">Place Order</button>
        <a href="/collections/all" class="link-more" style="display:block; text-align:center; margin-top:14px;">&larr; Continue Shopping</a>
      </div>
    </div>
  `;

  wireCartPageEvents();
}

function wireCartPageEvents() {
  document.querySelectorAll("[data-qty-minus]").forEach(btn => {
    btn.addEventListener("click", async () => {
      const valueEl = btn.parentElement.querySelector(".qty-value");
      const newQty = Math.max(0, (parseInt(valueEl.textContent, 10) || 1) - 1);
      const cart = await changeCartLine(btn.dataset.line, newQty);
      if (cart) renderCartPage(cart);
    });
  });
  document.querySelectorAll("[data-qty-plus]").forEach(btn => {
    btn.addEventListener("click", async () => {
      const valueEl = btn.parentElement.querySelector(".qty-value");
      const newQty = Math.min(99, (parseInt(valueEl.textContent, 10) || 1) + 1);
      const cart = await changeCartLine(btn.dataset.line, newQty);
      if (cart) renderCartPage(cart);
    });
  });
  document.querySelectorAll("#cart-page [data-remove]").forEach(btn => {
    btn.addEventListener("click", async () => {
      const cart = await changeCartLine(btn.dataset.line, 0);
      if (cart) renderCartPage(cart);
    });
  });
  document.getElementById("place-order")?.addEventListener("click", () => {
    window.location.href = "/checkout";
  });
}

document.addEventListener("DOMContentLoaded", async () => {
  if (!document.getElementById("cart-page")) return;
  // Swap the server-rendered no-JS form for the AJAX-driven version.
  const res = await fetch("/cart.js");
  const cart = await res.json();
  renderCartPage(cart);
});
